const containsErrorType = (error, type) =>
  error?.graphQLErrors?.some(({ extensions }) => extensions?.exception?.type === type);

const isInvalidTokenError = (error) =>
  error?.graphQLErrors?.some((e) => e.message?.includes('Invalid token'));

export { containsErrorType, isInvalidTokenError };
